interface ErrorBannerProps {
  message: string | null;
}

export function ErrorBanner({ message }: ErrorBannerProps): JSX.Element | null {
  if (!message) return null;
  return (
    <div className="banner banner--error" role="alert">
      <span aria-hidden="true">!</span>
      <span>{message}</span>
    </div>
  );
}
